import { FEATURES } from "@/lib/constants";
import {
  MessageSquare,
  PhoneForwarded,
  CalendarDays,
  Filter,
  Star,
  Smartphone,
  Zap,
} from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const iconMap = {
  MessageSquareLightning: MessageSquare,
  PhoneForwarded,
  CalendarDays,
  GitPullRequestDraft: Filter,
  Star,
  Smartphone,
};

export default function FeaturesGrid() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      id="features"
      data-testid="features-section"
      className="bg-white py-16 md:py-24"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <h2 className="font-heading text-3xl md:text-5xl font-semibold text-[#1A1A1A] text-center tracking-tight mb-12 md:mb-16">
          {FEATURES.heading}
        </h2>

        <div
          ref={ref}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8"
        >
          {FEATURES.items.map((feature, i) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={feature.title}
                data-testid={`feature-card-${i}`}
                className={`bg-white border border-gray-200 p-6 md:p-8 rounded-xl group hover:border-[#20611B] transition-all duration-500 hover:shadow-md ${
                  isVisible
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-6"
                }`}
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-[#D8FFB8] flex items-center justify-center mb-5 group-hover:bg-[#20611B] transition-colors relative">
                  {Icon && (
                    <Icon className="h-6 w-6 text-[#20611B] group-hover:text-white transition-colors" />
                  )}
                  {feature.icon === "MessageSquareLightning" && (
                    <Zap className="h-3.5 w-3.5 text-[#D4A84B] absolute -top-1 -right-1" />
                  )}
                </div>
                <h3 className="font-heading text-lg font-semibold text-[#1A1A1A] mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-[#6B7280] leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
